<template>
    <div>
      <Head>
        <title>{{course.title}} - Ireland Course</title>
        <link rel="canonical" :href="'https://backtoworkconnect.ie/course/'+course.alias" />
        <meta head-key="description" name="description" :content="course.description" />
      </Head>

      <v-container class="lighten-5" style="padding-bottom:65px">
        <BackButton></BackButton>
        <v-card elevate>
            <v-card-title>
                {{course.title}}
                <template v-if="canApply()">
                    <v-spacer></v-spacer>
                    <v-icon v-if="!isFavorite" @click="triggerAddFavorite()" class="m-5" color="primary">mdi-heart-outline</v-icon>
                    <v-icon v-if="isFavorite" @click="triggerDelFavorite()" class="m-5" color="primary">mdi-heart</v-icon>
                    <v-btn v-if="!isApplied" @click="triggerApply()" color="primary"><v-icon class="mr-3">mdi-send</v-icon>Contact the College</v-btn>
                    <v-btn v-if="isApplied" color="secondary"><v-icon class="mr-3">mdi-check</v-icon>Information requested</v-btn>
                </template>
            </v-card-title>
            <v-card-text>
                <v-card outlined elevation="2" shaped class="hidden-md-and-down" style="width:400px;float:right">
                    <v-card-title class="bottom-border-purple mb-3 text-h6">Company Information</v-card-title>
                    <v-card-subtitle class="mt-3"><span class="text-h6">{{course.organization.name}}</span></v-card-subtitle>
                    <v-card-text>
                        <v-img :src="baseurl + '/img/' + course.organization.photo_path"></v-img>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <a :href="baseurl+'/organization/'+course.organization.alias"><v-btn outlined primary>View Company Details</v-btn></a>
                    </v-card-actions>
                </v-card>
                <v-container>
                    <v-row>
                        <v-col md="12" lg="4"
                            style="padding:4px !important;">
                            <span class="text-lg-h6">Category <v-icon>mdi-shape</v-icon></span>
                            <p v-html="course.category.title"></p>
                        </v-col>
                        <v-col md="12" lg="4" v-if="course.region"
                            style="padding:4px !important;">
                            <span class="text-lg-h6 text-md-body-1">Location <a :href="getUrl()" target="_blank"><v-icon>mdi-map</v-icon></a></span>
                            <p><span v-if="course.address">{{ course.address }}</span>&nbsp;<span v-if="course.city">{{ course.city }}</span>&nbsp;<span v-if="course.postal_code">{{ course.postal_code }}</span>&nbsp;{{course.region}}&nbsp;<a :href="getUrl()" target="_blank"><v-icon>mdi-open-in-new</v-icon></a></p>
                        </v-col>
                        <v-col md="12" lg="4"
                            style="padding:4px !important;">
                            <span class="text-lg-h6">Awarding Body <v-icon>mdi-license</v-icon></span>
                            <p v-html="course.awarding_body"></p>
                        </v-col>
                        <v-col
                            style="padding:4px !important;"
                            cols="12"
                            sm="12"
                            md="12"
                            lg="4"
                            v-if="course.duration"
                        >
                            <span class="text-lg-h6">Duration <v-icon>mdi-calendar</v-icon></span>
                            <p>{{ course.duration }}</p>
                        </v-col>
                        <v-col
                            style="padding:4px !important;"
                            cols="12"
                            sm="12"
                            lg="4"
                            md="12" v-if="course.timetable"
                        >
                            <span class="text-lg-h6">Timetable <v-icon>mdi-calendar</v-icon></span>
                            <p>{{ course.timetable }}</p>
                        </v-col>
                        <v-col
                            style="padding:4px !important;"
                            cols="12"
                            sm="12"
                            lg="4"
                            md="12" v-if="course.start_date"
                        >
                            <span class="text-lg-h6">Start Date <v-icon>mdi-calendar</v-icon></span>
                            <p>{{ course.start_date }}</p>
                        </v-col>
                        <v-col
                            style="padding:4px !important;"
                            cols="12"
                            sm="12"
                            md="4"
                            v-if="course.contact_email"
                        >
                            <span class="text-lg-h6">Email <v-icon>mdi-email</v-icon></span>
                            <p>{{ course.contact_email }}</p>
                        </v-col>
                        <v-col
                            style="padding:4px !important;"
                            cols="12"
                            sm="12"
                            md="4" v-if="course.contact_phone"
                        >
                            <span class="text-lg-h6">Phone <v-icon>mdi-phone</v-icon></span>
                            <p>{{ course.contact_phone }}</p>
                        </v-col>

                    </v-row>
                    <v-row v-if="course.description">
                        <v-col md="12">
                            <span class="text-lg-h6">Description</span>
                            <p v-html="convertNR(course.description)"></p>
                        </v-col>
                    </v-row>
                    <v-row class="top-border-purple" v-if="course.course_content || course.learning_outcomes || course.entry_requirements">
                        <v-col cols="12" sm="12">
                            <p class="text-h5">Other Information</p>
                        </v-col>
                    </v-row>
                    <v-row v-if="course.course_content">
                        <v-col md="12">
                            <span class="text-lg-h6">Course Content</span>
                            <p v-html="convertNR(course.course_content)"></p>
                        </v-col>
                    </v-row>
                    <v-row v-if="course.entry_requirements">
                        <v-col md="12">
                            <span class="text-lg-h6">Entry Requirements</span>
                            <p v-html="convertNR(course.entry_requirements)"></p>
                        </v-col>
                    </v-row>
                    <v-row v-if="course.learning_outcomes">
                        <v-col md="12">
                            <span class="text-lg-h6">Learning Outcomes</span>
                            <p v-html="convertNR(course.learning_outcomes)"></p>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

        </v-card>  
        <v-card outlined elevation="24" shaped class="hidden-lg-and-up mt-5" >
            <v-card-title class="bottom-border-purple mb-3 text-h6">Company Information</v-card-title>
                    <v-card-subtitle class="mt-3"><span class="text-h6">{{course.organization.name}}</span></v-card-subtitle>
                    <v-card-text>
                        <v-img :src="baseurl + '/img/' + course.organization.photo_path"></v-img>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <a :href="baseurl+'/organization/'+course.organization.alias"><v-btn outlined primary>View Company Details</v-btn></a>
                    </v-card-actions>
            </v-card> 
      </v-container>
      <CourseApplyDialog 
        v-if="auth.user && !isApplied" 
        :user = "auth.user" 
        :dialog="applyDialog" 
        :course="course" 
        @close="applyDialog = false" 
        :baseurl="baseurl">
        </CourseApplyDialog>
      <v-app-bar class="fixedFooter"
  elevation="4"
        v-if="prevurl || !isApplied"
>
            <v-btn v-if="prevurl" :href="prevurl">Back</v-btn><v-spacer></v-spacer>
            <template v-if="canApply()">
                <v-btn @click="triggerApply()" v-if=" !isApplied" ><v-icon class="mr-3">mdi-plane</v-icon>Contact the College</v-btn>
                <v-btn v-if="isApplied" color="secondary" ><v-icon class="mr-3">mdi-check</v-icon>Information requested</v-btn>
            </template>
        </v-app-bar>
    </div>
</template>
<script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyLayout'
  import CourseApplyDialog from '@/Shared/CourseApplyDialog'
  import axios from 'axios'
  
  import BackButton from '@/Shared/BackButton'

  export default {
    props: {
      course: Object,
      auth: Object,
      state: String,
      isFavorite: Boolean,
      isApplied: Boolean,
      baseurl: String,
      prevurl: String,
    },
    components: {
      Head,
      BackButton,
      CourseApplyDialog
    },
    layout: Layout,
    data() {
        return {
            applyDialog: false,
        }
    },
    watch: {
    },
    created() {
    },
    methods: {
        convertNR(str) {

            return str.replaceAll('\n','<br/>').replaceAll('\r','<br/>').replaceAll('\t','&nbsp;&nbsp;')
        },
        canApply() {
            if (!this.auth.user || (this.auth.user.roles.includes('admin') || this.auth.user.roles.includes('user')))
                return true;
            else
                return false;
        },
        getUrl() {
            return 'https://www.google.com/maps/search/?api=1&query='+encodeURIComponent(this.course.address +','+this.course.region)

        },
      triggerApply() {
        /*console.log('trigger apply');
        if (!this.auth.user)
            this.$parent.$emit('toggleComponentLogin','courseapply-'+this.course.id);
        else if (this.course.course_link)
            window.open(window.location + '/apply')
        else
            this.applyDialog = true;*/

        window.open(this.baseurl+'/course/'+this.course.alias+'/apply');
        //window.open(window.location + '/apply');
            
      },
      triggerAddFavorite() {
        console.log('trigger addfavorite');
        if (!this.auth.user)
            this.$parent.$emit('toggleComponentLogin','courseaddfavorite-'+this.course.id);
        else
            this.$inertia.get(this.baseurl+"/user/course/addfavorite/"+this.course.id)
      },
      triggerDelFavorite() {
        console.log('trigger delfavorite',this.auth.user,this.baseurl+"/user/course/delfavorite/"+this.course.id);
        if (!this.auth.user)
          this.$parent.$emit('toggleComponentLogin','coursedelfavorite-'+this.course.id);
        else
            this.$inertia.get(this.baseurl+"/user/course/delfavorite/"+this.course.id);
      }
    },
  }
  </script>
  
  <style>
    .fixedFooter {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    color: white;
    text-align: center;
    }
    </style>